import { useLayoutEffect, useRef, useState } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { config } from 'app-config';

const history = createBrowserHistory({
  basename: config.BASE_ROUTE_PATH,
});
export default history;

// We have to do this since the models sometimes use routing outside of react
export function BrowserRouter({ children }) {
  let historyRef = useRef(history);

  let h = historyRef.current;
  let [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [h]);

  return (
    <Router
      basename=""
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={h}
    />
  );
}
